import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { useRepairsLogic } from './Repairs/useRepairsLogic';
import { MobileRepairsView } from './Repairs/MobileRepairsView';
import { DesktopRepairsView } from './Repairs/DesktopRepairsView';

interface MasterSheetRepairsProps {
  theJob: any;
  refreshRepairs: () => Promise<any>;
  initialValue?: string;
  setJob: any;
}

export const MasterSheetRepairs: React.FC<MasterSheetRepairsProps> = props => {
  const isMobile = useMediaQuery('(max-width:960px)');
  const logic = useRepairsLogic(props);

  if (isMobile) {
    return <MobileRepairsView logic={logic} />;
  }

  return <DesktopRepairsView logic={logic} />;
};

export default MasterSheetRepairs;
